<template>
  <div>
    <q-header elevated class="bg-headerColor text-black">
      <q-toolbar>
        <q-btn
          flat
          @click="toggleNav"
          color="headerButton"
          round
          dense
          icon="menu"
        ></q-btn>

        <autocomplete
          v-if="
            ['Admin', 'Sport Manager'].includes(currentUserData.role) &&
              siteArea == 'Entries' &&
              Array.isArray(associations)
          "
          dense
          label="Association"
          :items="associations"
          :itemsLoading="associationsLoading"
          option_label="association_name"
          option_value="id"
          :id="changeAssociation_id"
          @changed="
            val => {
              changeAssociation_id = val;
            }
          "
        />
        <div
          style="font-size: 16px; font-weight: 500"
          v-if="$route.name && $route.name.includes('waves') && competition"
          @click="test"
        >
          {{ competition.competition_name }}
        </div>
      </q-toolbar>
    </q-header>

    <q-drawer
      :mini="miniState"
      v-model="drawer"
      show-if-above
      :width="200"
      :breakpoint="400"
      elevated
    >
      <q-img class="bg-white userInfoSection" style="height: 200px">
        <div class="absolute-bottom bg-white">
          <!-- <div
            class="bg-white full-height full-width q-pa-sm"
            id="userInfoDiv"
            style="border-radius: 10px"
          > -->
          <q-avatar
            v-if="!miniState"
            size="56px"
            class="q-mb-sm bg-white"
            style="cursor: pointer"
            @click="$router.push('/userProfile')"
          >
            <img :src="currentUserData.profileImageUrl" />
          </q-avatar>
          <div class="row">
            <div v-if="!miniState" class="col-12">
              <div
                class="text-weight-bold text-accent"
                style="cursor: pointer"
                @click="$router.push('/userProfile')"
              >
                {{ currentUserData.name }} - {{ currentUserData.role }}
              </div>
              <div
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 100%;
                  cursor: pointer;
                "
                class="text-accent"
                @click="$router.push('/userProfile')"
              >
                {{ currentUserData.email }}
              </div>
            </div>
            <div v-if="!miniState" class="col-12">
              <q-btn
                label="Logout"
                color="primary"
                @click="$store.dispatch('auth/logout')"
                icon="mdi-logout"
                class="full-width"
                dense
                no-caps
              >
                <q-tooltip> Logout </q-tooltip>
              </q-btn>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </q-img>
      <div class="bg-white navBarLogo text-center">
        <h3 class="q-my-none">
          <q-btn-dropdown
            class="full-width text-capitalize"
            color="primary"
            :label="`${miniState ? '' : siteArea}`"
          >
            <q-list>
              <q-item
                v-if="['Admin', 'Sport Manager'].includes(currentUserData.role)"
                clickable
                v-close-popup
                @click="
                  $store.dispatch('settings/changeSiteArea', 'Design');
                  $router.push('/');
                "
              >
                <q-item-section>Design</q-item-section>
              </q-item>
              <q-separator />
              <q-item
                v-if="
                  [
                    'Admin',
                    'Sport Manager',
                    'Club Admin',
                    'Team Manager',
                    'Coach',
                    'Sports Coordinator',
                    'Junior Coordinator'
                  ].includes(currentUserData.role)
                "
                clickable
                v-close-popup
                @click="
                  $store.dispatch('settings/changeSiteArea', 'Entries');
                  $router.push('/');
                "
              >
                <q-item-section>Entries</q-item-section>
              </q-item>
              <q-separator />
              <q-item
                v-if="
                  [
                    'Admin',
                    'Waves Manager',
                    'Sport Manager',
                    'Official'
                  ].includes(currentUserData.role)
                "
                clickable
                v-close-popup
                @click="
                  $store.dispatch('settings/changeSiteArea', 'Officiating');
                  $router.push('/');
                "
              >
                <q-item-section>Officiating</q-item-section>
              </q-item>
              <q-separator />
              <q-item clickable v-close-popup @click="openLiveResults">
                <q-item-section>Waves Results</q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </h3>
      </div>
      <q-scroll-area
        style="height: calc(100% - 250px); border-right: 1px solid #ddd"
        class="bg-white"
      >
        <q-list padding class="text-accent">
          <div
            :key="`navLink_${index}`"
            v-for="(link, index) in displayedLinks"
          >
            <div
              v-if="
                competition &&
                  $route.name &&
                  $route.name.includes('waves') &&
                  link.name == 'wavesCompetitionsMarshalling'
              "
              class="text-center q-py-md text-bold"
              style="
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ competition.competition_name }}
              <q-tooltip>
                {{ competition.competition_name }}
              </q-tooltip>
            </div>
            <q-item
              v-if="
                !link.children &&
                  !$route.params[link.hideOnPathID] &&
                  (!link.showOnPathID || $route.params[link.showOnPathID])
              "
              v-ripple
              :to="link.to"
              :exact="!link.disableExact"
              active-class="activePage"
            >
              <q-item-section avatar>
                <q-icon
                  v-if="link.icon && !link.customIconSrc"
                  :color="link.iconColor ? link.iconColor : 'accent'"
                  :name="link.icon"
                ></q-icon>
                <q-img v-if="link.customIconSrc" :src="link.customIconSrc">
                </q-img>
                <q-tooltip v-if="miniState">{{ link.text }}</q-tooltip>
              </q-item-section>
              <q-item-section> {{ link.text }} </q-item-section>
            </q-item>
            <q-expansion-item
              v-else-if="
                !$route.params[link.hideOnPathID] &&
                  (!link.showOnPathID || $route.params[link.showOnPathID])
              "
              :ref="link.text"
              :group="link.text"
              :icon="link.icon"
              :label="link.text"
              expand-icon-class="activePage"
            >
              <q-list padding class="text-accent">
                <div
                  :key="`navLink_${childIndex}`"
                  v-for="(child, childIndex) in link.children"
                >
                  <q-item
                    v-if="!child.children"
                    v-ripple
                    :to="child.to"
                    :exact="!link.disableExact"
                    active-class="activePage"
                  >
                    <q-item-section avatar>
                      <q-icon
                        :color="child.iconColor ? child.iconColor : 'accent'"
                        :name="child.icon"
                      ></q-icon>
                      <q-tooltip v-if="miniState">{{ link.text }}</q-tooltip>
                    </q-item-section>
                    <q-item-section> {{ child.text }} </q-item-section>
                  </q-item>
                </div>
              </q-list>
            </q-expansion-item>
          </div>

          <q-item
            v-if="
              $route.name.includes('waves') &&
                competition &&
                currentUserData.role != 'Official'
            "
            v-ripple
            clickable
            @click="downloadOmega"
          >
            <q-item-section avatar>
              <q-icon color="accent" name="mdi-download"></q-icon>
            </q-item-section>

            <q-item-section> Omega Download </q-item-section>
          </q-item>

          <q-item
            v-if="currentUserData.impersonatingUser == true"
            v-ripple
            clickable
            @click="stopImpersonation"
          >
            <q-item-section avatar>
              <q-icon color="accent2" name="cancel"></q-icon>
            </q-item-section>

            <q-item-section> Stop Impersonation </q-item-section>
          </q-item>
          <q-item
            v-if="tutorials.length > 0"
            v-ripple
            clickable
            @click="tutorialsDialog = true"
          >
            <q-item-section avatar>
              <q-icon color="accent" name="mdi-youtube"></q-icon>
            </q-item-section>

            <q-item-section> Tutorials </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-drawer>
    <q-dialog v-model="tutorialsDialog" persistent max-width="90vw">
      <q-card
        v-if="tutorialsDialog"
        tile
        style="width: 90vw; height: 90vh; max-width: 90vw"
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <div style="display: inline-block" class="text-h6">
              Tutorials
            </div>
            <q-space />
            <q-btn round flat icon="mdi-close" @click="tutorialsDialog = false">
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="q-pa-none">
          <tutorialPopover @close="tutorialsDialog = false" />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";
import tutorialPopover from "@/components/tutorials/tutorialPopover.vue";

export default {
  components: { autocomplete, tutorialPopover },

  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      miniState: "settings/miniNavState",
      siteArea: "settings/siteArea",
      associations: "associations/list",
      associationsLoading: "associations/listLoading",
      competition: "competitions/current",
      tutorials: "tutorials/listBySection"
    })
  },

  data: () => ({
    drawer: false,

    // Navigation
    rolesAccess: {
      Admin: [
        "dashboard",
        "associations",
        "competitions",
        "management",
        "divisions",
        "disciplines",
        "questionTypes",
        "system",
        "users",
        "slsnz",
        "documentation",
        "settings",
        "entriesCompetitions",
        "entriesMembers",
        "entriesSupportTeam",
        "entriesReports",
        "entriesclubInfo",
        "wavesCompetitions",
        "wavesCompetitionsMarshalling",
        "wavesCompetitionsEntries",
        "wavesCompetitionsReports",
        "dqCodes",
        "awards",
        "pointsTable",
        "downloads",
        "tutorialManagement"
      ],
      "Waves Manager": [
        "dashboard",
        "system",
        "settings",
        "wavesCompetitions",
        "wavesCompetitionsMarshalling",
        "wavesCompetitionsEntries",
        "wavesCompetitionsReports"
        // "wavesCompetitionsLiveResults",
      ],
      "Sport Manager": [
        "dashboard",
        "associations",
        "competitions",
        "system",
        "settings",
        "entriesCompetitions",
        "entriesMembers",
        "entriesSupportTeam",
        "entriesReports",
        "entriesclubInfo",
        "wavesCompetitions",
        "wavesCompetitionsMarshalling",
        "wavesCompetitionsEntries",
        "wavesCompetitionsReports",
        "downloads"
        // "wavesCompetitionsLiveResults",
      ],
      Official: [
        "dashboard",
        "system",
        "settings",
        "wavesCompetitions",
        "wavesCompetitionsMarshalling",
        "wavesCompetitionsEntries",
        "wavesCompetitionsReports"
        // "wavesCompetitionsLiveResults",
      ],
      "Club Admin": [
        "dashboard",
        "entriesCompetitions",
        "entriesMembers",
        "entriesSupportTeam", // Users
        "entriesReports",
        "entriesclubInfo",
        "system",
        "settings"
      ],
      "Team Manager": [
        "dashboard",
        "entriesCompetitions",
        "entriesMembers",
        "entriesclubInfo",
        "system",
        "settings"
      ],
      Coach: [
        "dashboard",
        "entriesCompetitions",
        "entriesMembers",
        "entriesclubInfo",
        "system",
        "settings"
      ],
      "Sports Coordinator": [
        "dashboard",
        "entriesCompetitions",
        "entriesMembers",
        "entriesclubInfo",
        "system",
        "settings"
      ],
      "Junior Coordinator": [
        "dashboard",
        "entriesCompetitions",
        "entriesMembers",
        "entriesclubInfo",
        "system",
        "settings"
      ]
    },
    displayedLinks: [],
    links: [
      {
        to: "/",
        icon: "mdi-view-dashboard",
        text: "Dashboard",
        iconColor: "",
        name: "dashboard",
        siteArea: ["Design", "Entries", "Officiating"]
      },
      {
        to: "/associations",
        icon: "mdi-account-supervisor-circle",
        // customIconSrc: "/statics/icons/3.svg",
        text: "Associations",
        name: "associations",
        siteArea: ["Design"]
      },
      {
        to: "/competitions",
        icon: "mdi-calendar-range",
        text: "Competitions",
        name: "competitions",
        siteArea: ["Design"]
      },
      {
        to: "/reports",
        icon: "mdi-chart-histogram",
        text: "Reports",
        name: "downloads",
        siteArea: ["Design"]
      },
      {
        to: "/waves/competitions",
        icon: "mdi-calendar-range",
        text: "Competitions",
        name: "wavesCompetitions",
        siteArea: ["Officiating"]
      },

      {
        to: "/waves/competitions/:competitions_id/events",
        icon: "mdi-swim",
        text: "Marshalling/Results",
        name: "wavesCompetitionsMarshalling",
        disableExact: true,
        idInPath: true,
        showOnPathID: "competitions_id",
        siteArea: ["Officiating"]
      },
      {
        to: "/waves/competitions/:competitions_id/entries",
        icon: "mdi-account-group",
        text: "Entries",
        name: "wavesCompetitionsEntries",
        idInPath: true,
        showOnPathID: "competitions_id",
        siteArea: ["Officiating"]
      },
      {
        to: "/waves/competitions/:competitions_id/reports",
        icon: "mdi-chart-histogram",
        text: "Reports",
        name: "wavesCompetitionsReports",
        idInPath: true,
        showOnPathID: "competitions_id",
        siteArea: ["Officiating"]
      },
      {
        to: "/waves/competitions/:competitions_id/wavesResults",
        icon: "mdi-chart-histogram",
        text: "Waves Results",
        name: "wavesCompetitionsWavesResults",
        idInPath: true,
        showOnPathID: "competitions_id",
        siteArea: ["Officiating"]
      },

      {
        to: "/entries/competitions",
        icon: "mdi-calendar-range",
        text: "Competitions",
        name: "entriesCompetitions",
        siteArea: ["Entries"]
      },
      {
        to: "/entries/members",
        icon: "mdi-account-group",
        text: "Members",
        name: "entriesMembers",
        siteArea: ["Entries"]
      },
      {
        to: "/entries/supportTeam",
        icon: "mdi-account-group-outline",
        text: "Users",
        name: "entriesSupportTeam",
        siteArea: ["Entries"]
      },
      {
        to: "/entries/reports",
        icon: "mdi-chart-box",
        text: "Reports",
        name: "entriesReports",
        siteArea: ["Entries"]
      },
      {
        to: "/entries/clubInfo",
        icon: "mdi-home-circle-outline",
        text: "Club Info",
        name: "entriesclubInfo",
        siteArea: ["Entries"]
      },
      {
        link: "/management",
        icon: "mdi-cog",
        text: "Management",
        name: "management",
        siteArea: ["Design"],
        children: [
          {
            to: "/management/divisions",
            icon: "mdi-format-list-bulleted-type",
            text: "Divisions",
            name: "divisions",
            siteArea: ["Design"]
          },
          {
            to: "/management/disciplines",
            icon: "mdi-swim",
            text: "Disciplines",
            name: "disciplines",
            siteArea: ["Design"]
          },
          {
            to: "/management/questionTypes",
            icon: "mdi-help",
            text: "Questions",
            name: "questionTypes",
            siteArea: ["Design"]
          },
          {
            to: "/management/dqCodes",
            icon: "mdi-numeric",
            text: "DQ Codes",
            name: "dqCodes",
            siteArea: ["Design"]
          },
          {
            to: "/management/awards",
            icon: "mdi-file-certificate-outline",
            text: "Awards",
            name: "awards",
            siteArea: ["Design"]
          },
          {
            to: "/management/pointsTable",
            icon: "mdi-table-multiple",
            text: "Points Tables",
            name: "pointsTable",
            siteArea: ["Design"]
          },
          {
            to: "/management/tutorials",
            icon: "mdi-youtube",
            text: "Tutorials",
            name: "tutorialManagement",
            siteArea: ["Design"]
          }
        ]
      },
      {
        link: "/system",
        icon: "mdi-application",
        text: "System",
        name: "system",
        siteArea: ["Design", "Entries"],

        children: [
          {
            to: "/system/users",
            icon: "mdi-account-group",
            text: "Users",
            name: "users",
            siteArea: ["Design"]
          },
          {
            to: "/system/slsnz",
            icon: "mdi-domain",
            text: "SLSNZ",
            name: "slsnz",
            siteArea: ["Design"]
          },
          {
            to: "/system/documentation",
            icon: "mdi-file-document",
            text: "Documentation",
            name: "documentation",
            siteArea: ["Design"]
          },
          {
            to: "/system/siteSettings",
            icon: "mdi-cogs",
            text: "Settings",
            name: "settings",
            siteArea: ["Design", "Entries"]
          }
        ]
      }
    ],

    siteAreaMenu: false,

    changeAssociation_id: null,

    tutorialsDialog: false
  }),
  watch: {
    currentUserData: function() {
      if (["Waves Manager", "Official"].includes(this.currentUserData.role)) {
        this.$store.dispatch("settings/changeSiteArea", "Officiating");
      }
      if (
        [
          "Club Admin",
          "Team Manager",
          "Coach",
          "Sports Coordinator",
          "Junior Coordinator",
          "Athlete"
        ].includes(this.currentUserData.role)
      ) {
        this.$store.dispatch("settings/changeSiteArea", "Entries");
      }
      this.setLinks();
      this.loadTutorials();
      if (!this.associations.length) {
        this.$store.dispatch("associations/loadAll");
      }
      if (this.$route.name && this.$route.name.includes("waves")) {
        this.$store.dispatch(
          "competitions/loadByID",
          this.$route.params.competitions_id
        );
      }
      this.changeAssociation_id = JSON.parse(
        JSON.stringify(this.currentUserData.currentAssociation_id)
      );
    },
    siteArea: function() {
      this.setLinks();
      this.loadTutorials();
    },
    $route: function() {
      this.setLinks();
      if (this.$route.name.includes("waves")) {
        this.$store.dispatch(
          "competitions/loadByID",
          this.$route.params.competitions_id
        );
      }
    },
    changeAssociation_id: function() {
      if (
        this.changeAssociation_id != this.currentUserData.currentAssociation_id
      ) {
        this.$store
          .dispatch(
            "users/devChangeClubAdminAssociation",
            this.changeAssociation_id
          )
          .then(() => {
            // this.$router.go();
            this.$store.dispatch("auth/loadCurrentUserData");
          });
      }
    }
  },
  beforeCreate() {},
  mounted() {
    this.changeAssociation_id = JSON.parse(
      JSON.stringify(this.currentUserData.currentAssociation_id)
    );

    if (typeof this.currentUserData.role != "undefined") {
      // if (this.links.length < 1) {
      this.setLinks();
      this.loadTutorials();
      this.$store.dispatch("associations/loadAll");
      this.$store.dispatch(
        "competitions/loadByID",
        this.$route.params.competitions_id
      );
      // }
    }
  },
  methods: {
    setLinks() {
      this.displayedLinks = this.checkLinkPerms(this.links);
    },
    checkLinkPerms(links) {
      let newLinks = [];
      links.forEach(link => {
        let newLink = JSON.parse(JSON.stringify(link));
        if (
          this.rolesAccess[this.currentUserData["role"]].includes(link.name) &&
          link.siteArea.includes(this.siteArea)
        ) {
          if (newLink.idInPath) {
            let regex = /:.*/;
            let value = newLink.to.match(regex)[0].split("/")[0];

            newLink.to = newLink.to.replace(
              value,
              this.$route.params[value.substring(1)]
            );
          }

          if (link.children) {
            newLink.children = this.checkLinkPerms(link.children);
          }
          newLinks.push(newLink);
        }
      });
      return newLinks;
    },
    toggleNav() {
      if (this.$q.screen.lt.sm) {
        this.drawer = !this.drawer;
      } else {
        this.$store.dispatch("settings/togglMiniNav");
      }
    },
    stopImpersonation() {
      this.$store.dispatch("auth/impersonateStop");
    },
    openLiveResults() {
      window.open("https://www.wavesresults.surflifesaving.org.nz/", "_blank");
    },
    downloadOmega() {
      window.open(
        "https://nzsls.s3.ap-southeast-2.amazonaws.com/WavesResultsSync.zip",
        "_blank"
      );
    },
    loadTutorials() {
      this.$store.dispatch("tutorials/loadAllBySection", this.siteArea);
    },
    test() {
      console.log(11111);
    }
  }
};
</script>

<style lang="scss" scoped>
.activePage {
  border-left: 3px solid $primary;
  background-image: linear-gradient(
    to left,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.2)
  );

  div {
    color: $primary;
  }

  i {
    color: $primary;
  }
}
.userInfoSection {
  border-right: 1px solid white;
  border-bottom: 1px solid $accent2;

  #userInfoDiv:hover {
    background: black;
  }
}
.navBarLogo {
  height: 50px;
  border-right: 1px solid white;
  h3 {
    color: white;
    text-align: center;
    font-size: 12pt;
    font-weight: bold;
  }
}
</style>
